<template>
    <div class="container">
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <v-row>
                <v-col cols="7">
                    <div style="padding:20px 60px;border:1px solid #1E1E1E">
                                <p v-if="taxDetail.vat_price && taxDetail.vat_price > 0" class="mb-0"
                                    style="text-align:center;font-size:20px;color:#058DC2;font-weight:500">
                                    ใบเสร็จรับเงิน / ใบกำกับภาษี
                                </p>
                                <p v-else class="mb-0"
                                    style="text-align:center;font-size:20px;color:#058DC2;font-weight:500">
                                    ใบเสร็จรับเงิน
                                </p>
                                <p class="mb-0" style="text-align:center;font-size:15px;color:#000000;font-weight:500">
                                    <u>ต้นฉบับ</u>
                                </p>
                            </div>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="4" style="display: grid;align-items:center">
                    <p class="mb-0" color="#1E1E1E" style="font-size:15px;font-weight:500;">
                        <span class="page-number" style="color:#058DC2"></span>
                    </p>
                    <p class="mb-0" color="#1E1E1E" style="font-size:15px;font-weight:500;">
                        <span style="color:#058DC2">วันที่ </span>{{ currentDate }}
                    </p>
                    <p class="mb-0" color="#1E1E1E" style="font-size:15px;font-weight:500;">
                        <span style="color:#058DC2">เลขที่ </span>{{ taxDetail.code }}
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="7">
                    <div>
                        <p class="" color="#3B3B3B" style="font-size:16px;font-weight:400;">{{
                            taxDetail.address_bill }}</p>
                        <p class="" color="#3B3B3B" style="font-size:16px;font-weight:400;">{{ taxDetail.company_address
                            }}</p>
                        <p class="" color="#3B3B3B" style="font-size:16px;font-weight:400;">
                            เลขประจำตัวผู้เสียภาษี: {{ taxDetail.tax_number }}</p>
                    </div>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="4">
                    <img v-if="taxDetail.logo_image === 'null'" :src="image_mockup" alt="logo"
                        style="width:120px;height:120px;">
                    <img v-else :src="taxDetail.logo_image" alt="logo" style="width:120px;height:120px;">
                </v-col>
            </v-row>
            <div style="display:flex;justify-content:space-between;align-items:center">
                <p style="color:#058DC2;font-size:16px;font-weight:400;">ลูกค้า&nbsp;<span style="color:#3B3B3B;">{{
                    taxDetail.customer_name
                        }}<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เลขที่
                        {{ taxDetail.address }} {{
                            taxDetail.district }} {{ taxDetail.amphoe }} {{ taxDetail.province }} {{
                            taxDetail.zipcode }}</span></p>
                <p style="color:#3B3B3B;font-size:16px;font-weight:400;text-align:end;">เลขประจำตัวผู้เสียภาษี{{
                    taxDetail.tax_number_cus }}</p>
            </div>
            <!-- <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                   
                </v-col>
            </v-row> -->
            <v-row>
                <v-col cols="12">
                    <v-simple-table>
                        <template v-slot:default>
                            <thead class="top-invoice-border">
                                <tr style="color:#3B3B3B;">
                                    <th class="text-center">
                                        <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                            ลำดับ
                                        </p>
                                    </th>
                                    <th class="text-center">
                                        <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                            รายการ
                                        </p>
                                    </th>
                                    <th class="text-center">
                                        <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                            จำนวน
                                        </p>
                                    </th>
                                    <th class="text-center">
                                        <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                            ราคาต่อหน่วย
                                        </p>
                                    </th>
                                    <th class="text-center">
                                        <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                            จำนวนเงิน
                                        </p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="invoice_border invoice_border_last_data"
                                v-if="taxDetail.type_show_data === 1">
                                <tr style="color:#3B3B3B;">
                                    <td class="text-center">
                                        <p style="font-size:16px;font-weight:300;text-align:center;">1</p>
                                    </td>
                                    <td>
                                        <!-- ถ้ามี Topic ให้ใส่ margin top 10px; ถ้าไม่มี Topic ให้เอาออก -->
                                        <p class="mb-0" style="font-size:16px;font-weight:300">
                                            อาหารและเครื่องดื่ม</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="mb-0" style="font-size:16px;font-weight:300;text-align:center;"></p>
                                    </td>
                                    <td class="text-center">
                                        <div>
                                            <p class="mb-0" style="font-size:16px;font-weight:300;text-align:center;">
                                                {{ formatNumber(taxDetail.price) }}</p>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div>
                                            <p class="mb-0" style="font-size:16px;font-weight:300;text-align:center;">
                                                {{ formatNumber(taxDetail.total_price) }}</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody class="invoice_border invoice_border_last_data" v-else>
                                <tr style="color:#3B3B3B;" v-for="(items, index) in foodItems" :key="index">
                                    <template>
                                        <td class="text-center">
                                            <p style="font-size:16px;font-weight:300;text-align:center;">{{ index + 1 }}</p>
                                        </td>
                                        <td>
                                            <!-- ถ้ามี Topic ให้ใส่ margin top 10px; ถ้าไม่มี Topic ให้เอาออก -->
                                            <p class="mb-0" style="font-size:16px;font-weight:300;"
                                                :style="items.topping_list.length > 0 ? 'margin-top:10px;' : ''">
                                                {{ items.name }}
                                            </p>
                                            <div style="text-indent: 25px;font-size:16px;font-weight:300"
                                                v-if="items.topping_list.length > 0">
                                                <li v-for="(topping, index) in items.topping_list" :key="index">
                                                    {{ topping.topping_name }}
                                                </li>
                                            </div>

                                        </td>
                                        <td class="text-center">
                                            <p class="mb-0" style="font-size:16px;font-weight:300;text-align:center;">
                                                {{ items.amount }}</p>
                                        </td>
                                        <td class="text-center">
                                            <div>
                                                <p class="mb-0"
                                                    style="font-size:16px;font-weight:300;text-align:center;">
                                                    {{ formatNumber(items.price) }}</p>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div>
                                                <p class="mb-0"
                                                    style="font-size:16px;font-weight:300;text-align:center;">
                                                    {{ formatNumber(items.total_price) }}</p>
                                            </div>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                            <tfoot class="invoice_border">
                                <tr style="color:#3B3B3B;" v-if="taxDetail.vat_price && taxDetail.vat_price > 0">
                                    <td colspan="3" class="text-right"></td>
                                    <td class="text-center">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            ราคาก่อนภาษี</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            {{ formatNumber(taxDetail.price) }}</p>
                                    </td>
                                </tr>
                                <tr style="color:#3B3B3B;" v-else>
                                    <td colspan="3" class="text-right"></td>
                                    <td class="text-center">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            รวมเงิน</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            {{ formatNumber(taxDetail.price) }}</p>
                                    </td>
                                </tr>
                              
                                <tr style="color:#3B3B3B;" v-if="taxDetail.vat_price && taxDetail.vat_price > 0">
                                    <td colspan="3" class="text-left">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B; padding-left:60px">
                                            ({{ convertNumberToText(taxDetail.reccive_money) }})</p>
                                    </td>
                                    <td class="text-center" v-if="taxDetail.vat_price && taxDetail.vat_price > 0">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            vat 7%</p>
                                    </td>
                                    <td class="text-center" v-if="taxDetail.vat_price && taxDetail.vat_price > 0">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            {{ formatNumber(taxDetail.vat_price) }}</p>
                                    </td>
                                </tr>

                                <tr style="color:#3B3B3B;" v-if="taxDetail.vat_price && taxDetail.vat_price > 0">
                                    <td colspan="3" class="text-left">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#058DC2; padding-left:60px">
                                            การชำระเงิน : <span style="color:#3B3B3B;text-align:center;">{{
                                                taxDetail.payment_method === 0 ? 'เงินสด' :
                                                    taxDetail.payment_method === 1 ? 'เงินโอน' : 'อื่นๆ'
                                            }}</span>
                                        </p>
                                    </td>
                                    <td class="text-center">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            ราคารวมภาษีมูลค่าเพิ่ม</p>
                                    </td>
                                    <td class="text-center" v-if="taxDetail.vat_price && taxDetail.vat_price > 0">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            {{
                                                formatNumber(taxDetail.total_price)
                                            }}</p>
                                    </td>
                                </tr>
                                <tr style="color:#3B3B3B;"
                                    v-if="taxDetail.service_charge && taxDetail.service_charge > 0">
                                    <td colspan="3" class="text-right"></td>
                                    <td class="text-center">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            ค่าบริการ {{ taxDetail.percen_service_charge }}%</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            {{ formatNumber(taxDetail.service_charge) }}</p>
                                    </td>
                                </tr>
                                <tr style="color:#3B3B3B;">
                                    <td colspan="3" class="text-left">

                                    </td>
                                    <td class="text-center" style="border-bottom: 1px solid #058DC2 !important;">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            จำนวนเงินทั้งสิ้น</p>
                                    </td>
                                    <td class="text-center" style="border-bottom: 1px solid #058DC2 !important;">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            {{ formatNumber(taxDetail.total_price) }}</p>
                                    </td>
                                </tr>
                                <tr style="color:#3B3B3B;">
                                    <td class="text-center" colspan="3">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B; padding-left:60px">
                                            ผู้รับเงิน......................................................................
                                        </p>
                                    </td>
                                    <td class="text-center">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            ส่วนลด</p>
                                    </td>
                                    
                                    <td class="text-center">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B;text-align:center;">
                                            {{ formatNumber(taxDetail.discount) }}</p>
                                    </td>
                                </tr>
                                <tr style="color:#3B3B3B;">
                                    <td class="text-center" colspan="3">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:400;color:#3B3B3B; padding-left:90px">
                                            (......................................................................)</p>
                                    </td>
                                    <td class="text-center" style="border-bottom: 2px solid #058DC2 !important;">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:500;color:#058DC2;text-align:center;">
                                            ยอดชำระ</p>
                                    </td>
                                    <td class="text-center" style="border-bottom: 2px solid #058DC2 !important;">
                                        <p class="mb-0"
                                            style="font-size:16px;font-weight:500;color:#3B3B3B;text-align:center;">
                                            {{ formatNumber(taxDetail.reccive_money) }}</p>
                                    </td>
                                </tr>
                            </tfoot>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import before_image from "@/assets/ZoftConnect_Logo_Black_for_Bill_150px.png";
import { HTTP } from "@/axios.js"; // นำเข้า axios เพื่อใช้ดึงข้อมูลจาก API
export default {
    name: 'billretrospect',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            image_mockup: before_image,
            taxDetail: {}, // เก็บข้อมูลใบกำกับภาษี
            foodItems: [], // เก็บข้อมูลรายการอาหาร
            taxDetail_food: [], // เก็บข้อมูลรายการอาหาร
            invoiceId: this.$route.params.id, // ใช้ id ของใบกำกับภาษีจาก route
            currentDate: this.formatDate(new Date()), // ตั้งค่าข้อมูลวันที่ปัจจุบัน
            currentTime: this.formatTime(new Date()),  // สำหรับเวลาปัจจุบัน
        }
    },
    methods: {
        async getInvoiceData() {
            try {
                const response = await HTTP.get(`POS/table/invoice-detaile/${this.$route.params.id}`, {
                    headers: {
                        Authorization: `Bearer ${this.$store.state.token}`,
                    },
                });

                if (response.data.successful === true) {
                    this.taxDetail = response.data.invoiceDetaile;
                    this.taxDetail_food = response.data.listnoBuffet;
                    this.foodItems = this.taxDetail_food; // สมมุติว่าข้อมูลรายการอาหารเก็บใน `items`
                    this.loading_page = false; // ปิด loading เมื่อดึงข้อมูลสำเร็จ
                    // สั่งพิมพ์อัตโนมัติหลังจากโหลดข้อมูลสำเร็จ
                    this.$nextTick(() => {
                        window.print();
                    });
                }
            } catch (error) {
                if (error.response.status === 401) {
                    this.$store.commit("logOutSuccess");
                    this.$router.push("/login");
                }
            }
        },
        formatNumber(value) {
            return new Intl.NumberFormat('th-TH', {
                style: 'currency',
                currency: 'THB',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },
        formatDate(dateString) {
            if (!dateString) return "-"; // ถ้าไม่มีค่าส่งกลับ "-"
            
            const date = new Date(dateString); // แปลงเป็น Date object
            const options = { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
            };
            
            let thaiDate = date.toLocaleDateString('th-TH', options); // แปลงเป็นวันที่แบบไทย
            return thaiDate;
        },
        formatTime(date) {
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');
            return `${hours}:${minutes}:${seconds} น.`; // แสดงผลเวลาปัจจุบัน
        },
        convertNumberToText(num) {
            const numberToText = require('thai-baht-text'); // ใช้ไลบรารีแปลงตัวเลขเป็นข้อความภาษาไทย
            return numberToText(num);
        }
    },
    mounted() {
        this.getInvoiceData(); // เรียก API เมื่อ component โหลดเสร็จ
        // ฟังก์ชันที่ทำงานก่อนพิมพ์
        window.onbeforeprint = function () {
            const totalPages = Math.ceil(document.body.scrollHeight / window.innerHeight);
            const pageNumbers = document.querySelectorAll('.page-number');

            pageNumbers.forEach((element, index) => {
                element.textContent = `หน้า ${index + 1}/${totalPages}`;
            });
        };

        // คุณอาจจะใช้ afterprint เพื่อคืนค่าเดิมเมื่อพิมพ์เสร็จ
        window.onafterprint = function () {
            const pageNumbers = document.querySelectorAll('.page-number');

            pageNumbers.forEach((element) => {
                element.textContent = "";
            });
        };
    },
    watch: {
        taxDetail: {
            handler(newVal) {
                if (newVal.created_at) {
                    this.currentDate = this.formatDate(new Date(newVal.created_at));
                }
            },
            deep: true
        }
    },
}
</script>
<style>
.confirm_invoice_button {
    width: 50% !important;
}

.top-invoice-border>tr>th {
    border-top: 2px solid #058DC2 !important;
    border-bottom: 2px solid #058DC2 !important;
}

.invoice_border>tr>td {
    border: none !important;
}

.invoice_border_last_data>tr:last-child td {
    border-bottom: 2px solid #058DC2 !important;
}

.print_invoice_button {
    background-image: linear-gradient(to bottom, #51BDE7, #058DC2);
    border-radius: 5px;
}

@media screen and (max-width: 768) {
    .confirm_invoice_button {
        width: 100% !important;
    }
}

@media print {
    /* ป้องกันการตัดหน้าในส่วนที่ไม่ต้องการ */

    /* ตั้งค่าขนาดของหน้ากระดาษเป็น A4 */
    @page {
        size: A4;
        margin: 10mm;
    }

    .container {
        width: 210mm;
        height: auto;
        padding: 10mm;
    }

    /* ซ่อนส่วนที่ไม่ต้องการแสดงตอนพิมพ์ เช่น ปุ่มต่าง ๆ */
    .print_invoice_button,
    .confirm_invoice_button {
        display: none !important;
    }

    /* ปรับฟอนต์คงที่และไม่ถูกย่อขนาด */
    * {
        font-size: 12pt !important;
        line-height: 1.4 !important;
    }

    img {
        max-width: 100%;
        height: auto;
    }
}
</style>